import { render } from "./HeroiconsOutlineDocumentDownload.vue?vue&type=template&id=30d19eee"
const script = {}

import exportComponent from "/var/www/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineDocumentDownload.vue"]])

export default __exports__